// eslint-disable-next-line
declare var __webpack_public_path__: string;
declare global {
  interface Window {
    shoutoutTranslationsConfig: TranslationsConfig;
  }
}

import { setTranslations } from './angular-translate';

type TranslationsConfig = {
  staticsUrl: string;
  locale: string;
};

export async function getTranslations(locale: string): Promise<any> {
  const { default: translations } = await import(
    /* webpackMode: "lazy", webpackChunkName: "i18n-[index]" */
    '../locale/messages_' + locale + '.json'
  );

  return translations;
}

export async function loadTranslations({ staticsUrl, locale }: TranslationsConfig): Promise<void> {
  // eslint-disable-next-line
  __webpack_public_path__ = staticsUrl;

  const translations = await getTranslations(locale);

  setTranslations(translations, locale);
}

export async function loadTranslationsFromWindowConfig(): Promise<void> {
  const translationsConfig = window.shoutoutTranslationsConfig;

  if (translationsConfig) {
    delete window.shoutoutTranslationsConfig;

    return loadTranslations(translationsConfig);
  }
}
